<div class="wre-table-container w-100">
  <div
    #tableContainer
    class="table-responsive"
    (scroll)="offset = tableContainer.scrollLeft + 'px'">
    <table class="table wre-table fixed-column table-hover p-0 m-0">
      <thead class="text-center p-0 m-0" [style.left]="'-' + offset">
        <tr class="t-header">
          @if (isAddedorRemoved) {
            <th class="text-nowrap col-ellipsis column-active"></th>
          }
          <th class="text-nowrap col-ellipsis column-active"></th>
          <th class="text-nowrap col-ellipsis column-users">Name</th>
          <th class="text-nowrap col-ellipsis column-adgroups">Type</th>
          <th class="text-nowrap col-ellipsis column-email">Email Address/Id</th>
          <th class="text-nowrap col-ellipsis column-domain">Domain</th>
        </tr>
      </thead>

      <tbody class="p-0 m-0">
        @for (item of list; track item; let isLast = $last) {
          <tr class="tr-padding" [ngClass]="{ 'border-bottom': isLast }">
            @if (isAddedorRemoved) {
              <td class="text-nowrap col-ellipsis column-active">
                <i
                  class="far"
                  [ngClass]="{ 'fa-plus': item.isAdded, 'fa-minus': item.isRemoved }"></i>
              </td>
            }
            <td class="text-nowrap col-ellipsis column-active">
              <i
                class="far"
                [ngClass]="
                  item.type === UserType.adGroup
                    ? 'fa-users'
                    : item.type === UserType.servicePrinciple
                      ? 'fa-desktop'
                      : 'fa-user'
                "></i>
            </td>
            <td class="text-nowrap col-ellipsis column-users">
              @if (item.displayName && item.displayName.trim() === ',') {
                <span class="ps-3">&#x2015;</span>
              }
              @if (item.displayName && item.displayName.trim() !== ',') {
                <span>{{ item.displayName }}</span>
              }
            </td>
            <td class="text-nowrap col-ellipsis column-adgroups">
              {{
                item.type === UserType.adGroup
                  ? UserType.adGroup
                  : item.type === UserType.servicePrinciple
                    ? UserType.servicePrinciple
                    : 'User'
              }}
            </td>
            <td class="text-nowrap col-ellipsis column-email">
              @if (item.type !== UserType.adGroup) {
                <span>{{ item.email }}</span>
              }
              @if (item.type === UserType.adGroup) {
                <span>&#x2015;</span>
              }
            </td>
            <td class="text-nowrap col-ellipsis column-domain">
              @if (item.type === UserType.internalUser || item.type === UserType.adGroup) {
                <span class="badge bg-warning me-1">INT</span>
              }
              @if (item.type === UserType.externalUser) {
                <span class="badge bg-secondary">EXT</span>
              }
              @if (item.type === UserType.servicePrinciple) {
                <span>&#8212;</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
